export const TEXTS = {
  QUANTITY: 'Qty',
  DELIVERS_BY: 'Delivers by',
  PERCENTTAGE_OFF: '% off',
  VIEW_SIMILAR: 'View Similar',
  REMOVE: 'Remove',
  MOVE_TO_WISHLIST: 'Move to Wishlist',
  SIZE: 'Size ',
  RETURN: 'Return',
  SIZE_EXCHANGE: 'Size Exchange',
  NO_RETURN_EXCHANGE: 'No Return/Exchange',
  DAYS: 'Day',
  OOS_TEXT: 'Product is out of stock',
  IN_STOCK_LOWER_QUANTITY: ' in stock, lower quantity to proceed',
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const REMOVE_ACTION_NUDGE_THUMBNAIL_SIZE = 64;

export const REMOVE_PRODUCT_CART_BUTTON_SIZE = '24px';

export const DROPDOWNFILLED_ICON_SIZE = '12px';
export const VIEW_SIMILAR_ICON_SIZE = '18px';
export const QUICK_VIEW_EXPERIMENT = 'quick-view';
export const SIZE_SELECTOR_ON_CART_AB = 'size-selector-on-cart';
export const SIZE_SELECTOR_ON_CART_A = 'size-selector-on-cart-a';

export const ORANGE_STAR_ICON_URL = "https://images-static.nykaa.com/fashion-images/pub/media/star-orange.svg";
